import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=5b29f3ec&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=5b29f3ec&prod&lang=css&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=5b29f3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29f3ec",
  null
  
)

export default component.exports